// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_B","related":"e_C","breadCrumbs":"e_D","postTags":"e_E","sidebarPostNav":"e_F"};